/**
 * RedRock Monitoring Admin BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SearchServiceCentersDictionaryResponse } from './search-service-centers-dictionary-response';


export interface SearchServiceCentersDictionaryResponsePagedList { 
    totalCount?: number;
    items?: Array<SearchServiceCentersDictionaryResponse> | null;
}

